import { Box, IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import isImage from '@/utils/isImage';

type Props = {
  onClick: () => void;
  tourId: number;
  customButtonIcon: string;
};

export default function CustomButton({ onClick, tourId, customButtonIcon }: Props) {
  const [buttonUrl, setButtonUrl] = useState<string>();

  useEffect(() => {
    (async () => {
      const url = `${process.env.NEXT_PUBLIC_CDN}/tours/${tourId}/${customButtonIcon}`;
      const isValidImage = await isImage(url);
      if (isValidImage) {
        setButtonUrl(url);
      }
    })();
  }, [customButtonIcon, tourId]);

  return (
    <IconButton
      id="custom-button"
      sx={{
        borderRadius: '10px 0 0 10px',
        padding: '0',
        transition: 'all 0.2s ease-in-out',
        overflow: 'hidden',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        color: 'white',

        '&:hover': {
          opacity: 0.8,
          transform: 'scale(1.1)',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
      }}
      onClick={onClick}
    >
      {customButtonIcon ? (
        <Box
          component="img"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
          src={buttonUrl}
        />
      ) : (
        <i className="far fa-crown" />
      )}
    </IconButton>
  );
}
